import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import XIcon from '@heroicons/react/outline/XIcon';
import { useEmbed } from '@tribeplatform/react-sdk/hooks';
import { T } from '../../../i18n';
import { Container } from '../Container';
export const Embed = props => {
    const { node, editor } = props;
    const initialData = node.attrs.embed;
    const url = (initialData === null || initialData === void 0 ? void 0 : initialData.url) || node.attrs.url;
    const { data: embed } = useEmbed({
        variables: {
            url,
            options: JSON.stringify({
                iframe: '1',
                omit_script: '1',
            }),
        },
        useQueryOptions: {
            initialData,
            enabled: !!(initialData === null || initialData === void 0 ? void 0 : initialData.html),
        },
    });
    if (!embed && !url) {
        return (_jsx(Container, { ...props, children: _jsx(T, { id: "Generics.SomethingWentWrong", defaultMessage: "Something went wrong" }, void 0) }, void 0));
    }
    const previewProps = {
        dangerouslySetInnerHTML: { __html: embed === null || embed === void 0 ? void 0 : embed.html },
    };
    const onRemove = () => {
        editor.chain().removePreview(embed).run();
    };
    return (_jsxs(Container, { ...props, children: [(embed === null || embed === void 0 ? void 0 : embed.html) && _jsx("div", { ...previewProps }, void 0), _jsx("button", { type: "button", onClick: onRemove, className: "flex absolute top-0 end-0 m-1 p-1 z-10 w-8 h-8 items-center justify-center bg-surface rounded-full border", children: _jsx(XIcon, {}, void 0) }, void 0)] }, void 0));
};
//# sourceMappingURL=Embed.js.map